import React from 'react';
import glamorous from 'glamorous';
import {padTools} from '../../utils';
import {ASH} from '../../../../shared/style/colors';
import {PHONE_LANDSCAPE} from '../../../../shared/style/breakpoints';

const MAX_TOOLS = 3;

export const GridItem = glamorous.div(
  {position: 'relative', flexDirection: 'column'},
  ({col = 'auto', row = 'auto', sticky = false, span = null, hidden = false}) => ({
    gridColumn: span === null ? col : `span ${span}`,
    gridRow: row,
    background: 'white',
    padding: '30px 20px 30px 20px',
    borderRight: span === null ? `1px solid ${ASH}` : 0,
    borderBottom: `1px solid ${ASH}`,
    [PHONE_LANDSCAPE]: {
      padding: sticky ? 10 : '20px 10px 20px 10px'
    },
    position: sticky ? ['sticky', '-webkit-sticky'] : 'relative',
    top: 0,
    zIndex: sticky ? 100 : 'inherit',
    display: hidden ? 'none' : 'flex'
  })
);

export const border = (index, num, offset, lastRow) => {
  let override = {};
  if (index - offset === num - 1) {
    override.borderRight = 0;
  }
  if (lastRow) {
    override.borderBottom = 0;
  }
  return override;
};

const padding = titleRow => {
  let override = {};
  if (titleRow) {
    override.paddingBottom = 0;
  }
  return override;
};

export const RenderItems = ({
  tools,
  children,
  num = tools.length,
  lastRow = false,
  titleRow = false,
  offset = 0,
  emptySpaceComponent
}) => {
  const paddedTools = padTools(tools, MAX_TOOLS);

  return paddedTools.map((tool, index) =>
    tools.length === index && emptySpaceComponent ? (
      <GridItem
        key={index}
        style={{
          ...border(index, num, offset, lastRow || titleRow),
          ...padding(titleRow),
          paddingTop: 0,
          marginTop: -20
        }}
        data-notes={`index ${index} num ${num} offset ${offset}`}
      >
        {emptySpaceComponent}
      </GridItem>
    ) : (
      <GridItem
        key={index}
        style={{
          ...border(index, num, offset, lastRow || titleRow),
          ...padding(titleRow)
        }}
        hidden={index < offset || index >= num + offset}
        data-notes={`index ${index} num ${num} offset ${offset}`}
      >
        {!tool.loading && !tool.empty && children(tool, index)}
      </GridItem>
    )
  );
};
